import React, { FunctionComponent } from "react";
import { makeStyles } from "tss-react/mui";
import { Theme } from "@mui/material";
import BookingLine from "@/Domains/DispositionManagement/Components/DispositionBody/Elements/BookingLine";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";


interface GroupReservationLineProps {
    lineItem: any;
    contentWidth: number | undefined;
}

const useStyles = makeStyles()((theme: Theme) => ({
    groupInfoWrapper: {
        // @ts-ignore
        background: theme.palette.background.darker,
        marginBottom: 4,
        height: 52,
        overflow: "hidden",
        display: "flex",
        paddingLeft: 15,
        paddingRight: 15,
        paddingTop: 5,
        fontSize: 14,
    },

    groupInfoDescription: {
        flex: "4 1",
    },

    groupInfoId: {
        flex: "1 1",
        textAlign: "right",
        justifyContent: "flex-end",
    },

    groupRow: {
        // @ts-ignore
        background: theme.palette.background.darker,
        marginBottom: 4,
        height: 52,
    },

    groupInfo: {
        flex: "1 1",
        lineHeight: 1.1,
        paddingTop: 0,
        fontSize: 11,
        wordBreak: "break-all",
    },
}));

const GroupReservationLine: FunctionComponent<GroupReservationLineProps> = ({
    lineItem,
    contentWidth,
}): JSX.Element => {
    const { classes } = useStyles();
    const { t } = useTranslation();

    return (
        <>
            <div
                className={classes.groupInfoWrapper}
                style={{ width: "306px", float: "left" }}
            >
                <div className={classes.groupInfoDescription}>
                    <b>
                        {t("groupReservation.groupReservation")}
                      
                    </b>
                    <br />
                    <div
                        className={classes.groupInfo}
                        style={{ paddingTop: 0 }}
                    >
                        {t("groupReservation.group")} 
                        {lineItem.vehicleGroup?.vehicleGroupId} -
                        {lineItem.vehicleGroup?.description}
                    </div>
                </div>
                <div className={classes.groupInfoId}>
                    <p>
                        <b>{lineItem.vehicleGroup?.vehicleGroupId}</b>
                    </p>
                </div>
            </div>
            <div
                data-id={lineItem.bookingId}
                data-station={lineItem.startstation.stationId}
                style={{ width: "100%", paddingLeft: "306px" }}
                className={classes.groupRow}
            >
                {Object.keys(lineItem.reservations).map((contractId) => {
                    const reservation = lineItem.reservations[contractId];

                    return (
                        <BookingLine
                            key={reservation.bookingId}
                            lineItem={reservation}
                            setDragDropClass={false}
                            contentWidth={contentWidth}
                        />
                    );
                })}
            </div>
        </>
    );
};

export default React.memo(GroupReservationLine);
